import LegalLayout from "./LegalLayout";

export default function Shipping() {
  return (
    <LegalLayout title="Shipping & Delivery Policy" updated="10 February 2026">
      <p>
        <strong>Anubandh AI is a fully digital service.</strong> This policy clarifies how our
        digital &quot;delivery&quot; works — required by Razorpay and the Consumer Protection
        (E-Commerce) Rules, 2020.
      </p>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">1. No Physical Shipment</h2>
      <p>
        Anubandh AI does not sell or ship physical goods. We provide access to a digital Marriage
        Intelligence Platform via anubandh.ai. Nothing is couriered, mailed, or physically delivered.
      </p>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">2. Instant Digital Delivery</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li><strong>Free tier (Discovery):</strong> Activated immediately upon email verification at signup.</li>
        <li><strong>Paid tiers (Clarity, Journey):</strong> Activated within <strong>60 seconds</strong> of successful payment confirmation from Razorpay.</li>
        <li><strong>Marriage Intelligence Report:</strong> Generated on-demand for each match within <strong>~10 seconds</strong>.</li>
        <li><strong>Curated match set:</strong> Refreshed weekly, delivered via in-app notification, email, and (if opted in) WhatsApp.</li>
      </ul>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">3. Delivery Confirmation</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>You will receive an email receipt from Razorpay confirming payment.</li>
        <li>You will receive a welcome email from <strong>hello@anubandh.ai</strong> confirming subscription activation and the tier you have unlocked.</li>
        <li>Your Dashboard will immediately reflect the new tier and unlocked features.</li>
      </ul>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">4. If Delivery Fails</h2>
      <p>
        If your payment is successful but your subscription is not activated within 5 minutes,
        please:
      </p>
      <ol className="list-decimal pl-6 space-y-2">
        <li>Refresh your browser and re-check the Dashboard.</li>
        <li>Log out and log back in.</li>
        <li>Contact <a className="text-amber-700 underline" href="mailto:billing@anubandh.ai">billing@anubandh.ai</a> with your Razorpay transaction ID.</li>
      </ol>
      <p>
        We commit to activation within <strong>48 hours</strong>, or a full refund per our <a
        className="text-amber-700 underline" href="/refund">Refund Policy</a>.
      </p>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">5. Geographical Availability</h2>
      <p>
        Anubandh AI is currently available to users in India and to NRI / OCI users across
        supported countries. Some regional payment methods may not be available for international
        users; Razorpay international card support applies.
      </p>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">6. Support</h2>
      <ul className="list-none pl-0 space-y-1">
        <li><strong>Billing &amp; Delivery Queries:</strong> <a className="text-amber-700 underline" href="mailto:billing@anubandh.ai">billing@anubandh.ai</a></li>
        <li><strong>General Support:</strong> <a className="text-amber-700 underline" href="mailto:hello@anubandh.ai">hello@anubandh.ai</a></li>
        <li><strong>Response Time:</strong> Within 48 hours on business days (Mon–Fri).</li>
      </ul>

      <div className="mt-10 pt-6 border-t border-stone-200 text-xs text-stone-500">
        Since our service is delivered digitally and instantly, standard concepts of &quot;shipping
        address&quot; and &quot;tracking number&quot; do not apply. Your account itself is the delivery
        endpoint.
      </div>
    </LegalLayout>
  );
}
